import React, { useRef } from 'react'
import Cropper from "react-cropper";
import Cookies from 'js-cookie'
import TabComponent from "../components/TabDefaultComponent";
import { groupBy, tabs } from "../utils";
import customSortFunction from "../utils/arrays";
import { editdefaultvaluesuser, getUserDefault, getDefaultvalues, editdefaultvalues } from "../services/Form";
import { useHistory } from 'react-router-dom'
import Pool from '../UserPool'
import Loader from "../components/Loader";
import { amazonUploadProfileImage } from "../utils/amazonUploadProfileImage";
import { CognitoUserAttribute } from "amazon-cognito-identity-js";

import Sidebar from '../components/Sidebar'
export default function ChangePassword() {


  const history = useHistory()
  const [loading, setLoading] = React.useState(false);
  const [tabs, setTabs] = React.useState([]);
  const [tabs1, setTabs1] = React.useState([]);
  const [tabs2, setTabs2] = React.useState([]);
  const [tabsImage, setTabsImage] = React.useState({});
  const [response, setResponse] = React.useState(null);
  const [response1, setResponse1] = React.useState(null);
  const [response2, setResponse2] = React.useState(null);
  const [active, setActive] = React.useState("Single Family");
  const [active1, setActive1] = React.useState("Single Family");
  const [data, setData] = React.useState(null);
  const [submit, setSubmit] = React.useState(false);
  const [formId, setFormId] = React.useState(0);
  const [submit1, setSubmit1] = React.useState(false);
  const [submit2, setSubmit2] = React.useState(false);
  const [password, setPassword] = React.useState(null);
  const [newPassword, setNewPassword] = React.useState(null);
  const [loadingImage, setLoadingImage] = React.useState(false)
  const [alert, setAlert] = React.useState(false)
  const [alert2, setAlert2] = React.useState(false)
  const [alert3, setAlert3] = React.useState(false)
  const [alert4, setAlert4] = React.useState(false)
  const [msg, setMsg] = React.useState('Please enter old password')
  const [msg1, setMsg1] = React.useState('Please enter new password')
  const [msg2, setMsg2] = React.useState('Your password has been successfully changed.')
  const [msg4, setMsg4] = React.useState('Your Image has been successfully changed.')
  const [value, setValue] = React.useState(null);
  const [Crop, setCrop] = React.useState(null);
  const [classname, setclass] = React.useState("hide");
  const [classnametab, setclasstab] = React.useState("tab-content Tab-SingleFamily");




  const getSession = async () => {
    return await new Promise((resolve, reject) => {
      const user = Pool.getCurrentUser();
      if (user) {
        user.getSession((err, session) => {
          if (err) {
            reject();
          } else {
            const attributes = new Promise((resolve, reject) => {
              user.getUserAttributes((err, attributes) => {
                if (err) {
                  reject();
                } else {
                  const results = {};
                  for (let attribute of attributes) {
                    const { Name, Value } = attribute;
                    results[Name] = Value
                  }
                  resolve(results);
                }

              });
            });
            resolve({ user, ...session, ...attributes });
          }
        });
      } else {
        reject();
      }
    });
  };
  const onSubmit1 = (e) => {
    e.preventDefault();

    let Tab = e.target.id;
    let checkid = Tab.split('-')[0];



    setLoading(true);
    editdefaultvaluesuser("", 0, tabsImage, tabs1, Tab, "Admin").then((res) => {


      setSubmit1(true);
      setLoading(false);

    });


  };
  const handleselect = (name) => {

    setActive(name);
    setclasstab("tab-content Tab-" + name.replace(/\s/g, ""))
  }
  const onSubmit3 = (e) => {
    e.preventDefault();
    var isrequired = false;
    let Tab = e.target.id;
    let checkid = Tab.split('-')[0];

    const loaderElements = document.querySelectorAll('.loader123');
    loaderElements.forEach(loader => loader.style.display = loader.style.display === 'none' ? 'inline-block' : 'none');
    editdefaultvaluesuser(data, formId, tabsImage, tabs, Tab, "").then((res) => {


      const loaderElements = document.querySelectorAll('.loader123');
      loaderElements.forEach(loader => loader.style.display = loader.style.display === 'none' ? 'inline-block' : 'none');
      setSubmit(true);
      //setLoading(false);

    });

  };
  React.useEffect(() => {
    var username = Cookies.get("username").toLowerCase();
    console.log(username);

    if (username == "ryan" || username == "abdul") {
      setclass("mr-5")
    }
    getDefaultvalues().then(async (res) => {



      let structures = {};
      res.StructureTypes.map((str, index) => {
        let newArr = [];
        str.Calculations.map((item) => {
          newArr.push({
            Phase: item.Phase,
            ParameterTypeId: item.ParameterTypeId,
            ParameterId: item.ParameterId,
            ParameterName: item.ParameterName,
            value: item.value.replace(/['"]+/g, ""),
            ischecked: item.ischecked,
            structureType: str.StructureType,
            IsManual: item.IsManual,
            isComplete: item.isComplete,
            perhomevalue: item.perhomevalue,
            perprojectvalue: item.perprojectvalue,
            ParamOrder: item.ParamOrder,
            isadmin: 3,
          });
        });


        structures[str.StructureType] = groupBy(newArr, "Phase");
      });
      setTabs1(structures);
      setSubmit1(true);



      let Astructures = {};
      res.StructureTypes.map((str, index) => {
        let newArr = [];
        newArr.push({
          Phase: "Site Potential",
          ParameterTypeId: 2,
          ParameterId: 1000,
          ParameterName: "IsDefault",
          value: "",
          ischecked: 0,
          structureType: str.StructureType,
          IsManual: 12,
          isComplete: 0,
          perhomevalue: 55,
          perprojectvalue: 0,
          ParamOrder: 0.0,
          isadmin: 1,
        });
        str.Calculations.map((item) => {

          newArr.push({
            Phase: item.Phase,
            ParameterTypeId: item.ParameterTypeId,
            ParameterId: item.ParameterId,
            ParameterName: item.ParameterName,
            value: item.value.replace(/['"]+/g, ""),
            ischecked: item.ischecked,
            structureType: str.StructureType,
            IsManual: item.IsManual,
            isComplete: item.isComplete,
            perhomevalue: item.perhomevalue,
            perprojectvalue: item.perprojectvalue,
            ParamOrder: item.ParamOrder,
            isadmin: 1,
          });
        });

        Astructures[str.StructureType] = groupBy(newArr, "Phase");
      });
      setTabs2(Astructures);
      setSubmit2(true);
      setResponse2(res);
      setResponse1(res);

    });
    getUserDefault().then(async (res) => {
      console.log(res)


      // let resp = res.StructureTypes.Calculations.sort((a, b) => a.ParamOrder - b.ParamOrder);
      //setData(res.map((item) => ({ ...item, Value: item.value.replace(/['"]+/g, "") })));
      // let obj = groupBy(resp, "Phase");
      // setObject1(obj);
      let structures = {};
      res.StructureTypes.map((str, index) => {
        let newArr = [];
        str.Calculations.map((item) => {
          newArr.push({
            Phase: item.Phase,
            ParameterTypeId: item.ParameterTypeId,
            ParameterId: item.ParameterId,
            ParameterName: item.ParameterName,
            value: item.value.replace(/['"]+/g, ""),
            ischecked: item.ischecked,
            structureType: str.StructureType,
            IsManual: item.IsManual,
            isComplete: item.isComplete,
            perhomevalue: item.perhomevalue,
            perprojectvalue: item.perprojectvalue,
            ParamOrder: item.ParamOrder,
            isadmin: 0,
          });
        });
        structures[str.StructureType] = groupBy(newArr, "Phase");
      });
      setTabs(structures);
      setSubmit(true);
      setResponse(res);
    });

    var image = Cookies.get('Image');
    console.log(image);
    setValue(image);
    setCrop(image);

    // getSession().then((data) => {
    //   setValue(data["idToken"]["payload"]["custom:plan"]);
    //   console.log(data["idToken"]["payload"]["custom:plan"]);
    //   Cookies.set('Image', data["idToken"]["payload"]["custom:plan"]);
    //});
  }, []);
  const defaultSrc =
    "https://raw.githubusercontent.com/roadmanfong/react-cropper/master/example/img/child.jpg";

  const [image, setImage] = React.useState(defaultSrc);
  const [cropData, setCropData] = React.useState("#");
  const [cropper, setCropper] = React.useState();

  const getCropData = () => {
    console.log("cropper", cropper)
    if (typeof cropper !== "undefined") {
      setCrop(cropper.getCroppedCanvas().toDataURL());
    }
    let save1 = document.querySelector('.uploadimage');
    save1.classList.remove('hide');
    setValue("https://images-nwlt.s3-us-west-2.amazonaws.com/" + Cookies.get('username').replace(/\s/g, '') + ".jpg");
  };

  const setObject = async (image) => {
    let save = document.querySelector('.cropimage');
    let save1 = document.querySelector('.cropimage1');
    if (image.target.files.length) {
      // start file reader
      const reader = new FileReader();
      reader.onload = (image) => {
        if (image.target.result) {

          setImage(image.target.result);
          save.classList.remove('hide');
          save1.classList.remove('hide');
        }
      };
      reader.readAsDataURL(image.target.files[0]);
    }

  }
  function handleLogout() {
    Cookies.remove('username')
    Cookies.remove('city')
    Cookies.remove('UsedClicks')
    Cookies.remove('PerMonthClick')
    history.push('/login')
  }
  function handleChanePass() {
    history.push('/changePassword')
  }
  function handleSelectionCity() {

    history.push('/')
  }
  function handleProperty() {

    history.push('/main')
  }
  async function onSubmit(event) {

    event.preventDefault();
    setAlert4(false)
    setLoadingImage(true);
    let cropped = document.getElementById('cropped').src;
    let uploadedImage = await amazonUploadProfileImage(cropped, Cookies.get('username').replace(/\s/g, '') + ".jpg");
    getSession().then(({ user }) => {
      const attributes = [
        new CognitoUserAttribute({ Name: "custom:plan", Value: value }),
      ];
      user.updateAttributes(attributes, (err, result) => {
        if (err) console.error(err);
        console.log(result);
        if (result == "SUCCESS") {
          setAlert4(true);
          setLoadingImage(false);
          Cookies.set('Image', value);
          window.location.reload(true);
        }
      });
    });

  };

  async function handleRegister() {
    setAlert2(false)
    setAlert(false)
    setAlert3(false)
    if ((newPassword == "" && password == "") || (newPassword == null && password == null) || (newPassword == "" && password == null) || (newPassword == null && password == "")) {
      setMsg1('Please enter new password')
      setMsg('Please enter old password')
      setAlert(true)
      setAlert2(true)
    }
    if (newPassword == "" || newPassword == null) {
      setAlert(true)
    } else setAlert(false)
    if (password == "" || password == null) {
      setMsg('Please enter old password')
      setAlert2(true)
    }

    else {
      setLoading(true)
      getSession().then(({ user, email }) => {
        user.changePassword(password, newPassword, (error, result) => {

          if (error) {
            setMsg("Old password is incorrect or your attempt limit are reached.")
            setAlert2(true)
            setLoading(false)

          } else {
            setAlert3(true)
            setLoading(false)
            // console.log(result);
          }
        });
      });


    }
  }
  function checkLoaded() {
    return document.readyState === "complete" || document.readyState === "interactive";
  }
  return (
    <div id="wrapper" class="main_dashboard">
      <Sidebar main={"side-icon"} home={"side-icon"} pass={"side-icon active"} screen="Setting" />
      <div id="content-wrapper" class="d-flex flex-column">
        <div id="content" >

          <div class="container-fluid">
            <div class="row mb-2">
              <div class="col-md-12 heading-propaty">
                <h2>Settings</h2>
              </div>
              <div class="col-md-9">
                {!(checkLoaded) ? <Loader /> :
                  <>
                    <div class="table-content-propaty">

                      <ul class="nav nav-tabs">
                        <li class="active mr-5"><a class="nav-link active" data-toggle="tab" href="#home"><i class="fa fa-user mr-2"></i>Profile</a></li>
                        <li class="mr-5"><a class="nav-link " data-toggle="tab" href="#menu1"><i class="fa fa-sticky-note-o mr-2"></i>Defaults </a></li>
                        <li class={classname}><a class="nav-link " data-toggle="tab" href="#menu2"><i class="fa fa-sticky-note-o mr-2"></i>Admin Defaults </a></li>
                      </ul>

                      <div class="tab-content ">
                        <div id="home" class="card tab-pane fade in active show ">
                          <div class="row card-body  ">
                            <div class="col-md-6 " >
                              <h4>Change Password</h4>



                              <h6 class="text-center">
                                {alert3 && (
                                  <span style={{ color: 'green' }}>{msg2}</span>
                                )}</h6>
                              <div class="form-group">
                                <label>
                                  Old Password{' '}
                                  {alert2 && (
                                    <span style={{ color: 'red' }}>{msg}</span>
                                  )}
                                </label>
                                <input
                                  type="password"
                                  value={password}
                                  class="form-control"
                                  onChange={(e) => setPassword(e.target.value)}
                                />
                              </div>
                              <div class="form-group">
                                <label>
                                  New Password {alert && <span style={{ color: 'red' }}>{msg1}</span>}
                                </label>
                                <input
                                  type="password"
                                  class="form-control"
                                  value={newPassword}
                                  onChange={(e) => setNewPassword(e.target.value)}
                                />
                              </div>

                              <div class="form-group text-right mt-2 w-100">
                                <a class="btn btn-secondary" onClick={handleRegister}>
                                  {loading && <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>}
                                  Update Password
                                </a>
                              </div>





                            </div>

                            <div class="col-md-6"  >

                              <h4>Change Profile Picture</h4>

                              <h6 class="text-center">
                                {alert4 && (
                                  <span style={{ color: 'green' }}>{msg4}</span>
                                )}</h6>
                              <div class="col-md-12">
                                <div class="profile-pic-change d-flex">
                                  <img
                                    src={Crop}
                                    class="user-avatar"
                                    id="cropped"
                                  ></img>
                                  {/* <div class="box-2 img-result">
        
    {/* <img class="cropped" src="" alt="" id="cropped"></img> }
        </div> */}
                                  <div class="ml-3 form-group">
                                    <label >Upload Image</label>
                                    <input
                                      type="file"
                                      //value={value}
                                      onChange={(e) => setObject(e)}
                                      id={'paramUserImage'}
                                      accept="image/*"
                                      class="form-control"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="form-group text-right mt-2 w-100">
                                <a class="btn btn-secondary mr-2 hide save cropimage" onClick={getCropData}>

                                  Crop
                                </a>
                                <a class="btn btn-secondary hide uploadimage" onClick={onSubmit}>
                                  {loadingImage && <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>}
                                  Update Image
                                </a>
                              </div>

                              <div class="box-2">
                                <div class="result cropimage1 hide">
                                  <Cropper
                                    style={{ height: 200, width: "100%" }}

                                    initialAspectRatio={1}
                                    preview=".img-preview"
                                    src={image}
                                    viewMode={1}
                                    minCropBoxHeight={10}
                                    minCropBoxWidth={10}
                                    background={false}
                                    responsive={true}
                                    autoCropArea={1}
                                    checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
                                    onInitialized={(instance) => {
                                      setCropper(instance);
                                    }}
                                    guides={true}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div id="menu1" class="tab-pane fade m">

                          {!(response && response2) ? <Loader /> :
                            <>
                              {submit && (
                                <form class="">
                                  <ul class="nav mytab nav-pills justify-content-center mt-2" id="pills-tab" role="tablist">

                                    {Object.keys(tabs).map((name, item) => {
                                      let style = "nav-link ";
                                      let issingleFamily = false;
                                      let isNotsingleFamily = false;
                                      let isNotsingleFamilyCond = false;
                                      let isAptCond = false;
                                      let svgPath = ""; let svgPath1 = ""; let svgPath2 = ""; let svgPath3 = ""; let svgPath4 = "";
                                      let svgPath5 = ""; let svgPath6 = ""; let svgPath7 = ""; let svgPath8 = "";
                                      let viewBox = "0 1.117 17 14.767";

                                      if (active === name) style += "active";

                                      if (name == "Single Family") {
                                        issingleFamily = true;
                                        svgPath = "m16.667 7.379-4.16-3.096V.723A.725.725 0 0 0 11.784 0a.726.726 0 0 0-.724.723v2.484L8.89 1.59a.706.706 0 0 0-.832 0L.281 7.38c-.325.217-.361.65-.144.976.217.326.65.362.976.145l.724-.535v8.312c0 .397.325.723.723.723h11.864c.398 0 .723-.326.76-.723V8.016l.65.484c.145.109.29.145.435.145.217 0 .434-.073.542-.29.217-.289.181-.76-.144-.976Zm-9.115 8.21v-3.617h1.88v3.617h-1.88Zm6.185 0h-2.858v-4.34a.726.726 0 0 0-.723-.723H6.864a.726.726 0 0 0-.723.723v4.34H3.247V8.174h10.49v7.415ZM3.507 6.728l4.985-3.69 2.79 2.076c.045.043.095.08.15.11l2.02 1.504H3.508Z"
                                      }
                                      else if (name == "Townhome") {
                                        isNotsingleFamily = true;
                                        viewBox = "0";
                                        svgPath1 = "M13.357 26.493h1.435c1.104 0 2.208-.993 2.208-2.207a2.214 2.214 0 0 0-2.208-2.208h-1.435a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                                        svgPath2 = "M13.357 17.441h1.435c1.104 0 2.208-.993 2.208-2.207a2.214 2.214 0 0 0-2.208-2.208h-1.435a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                                        svgPath3 = "M37.09 26.493h1.436a2.214 2.214 0 0 0 2.208-2.207 2.214 2.214 0 0 0-2.208-2.208H37.09a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                                        svgPath4 = "M37.09 17.441h1.436a2.214 2.214 0 0 0 2.208-2.207 2.214 2.214 0 0 0-2.208-2.208H37.09a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                                        svgPath = "M51.773 49.785v-39.63c0-.993-.552-1.765-1.436-2.097L26.604.11c-.663-.22-1.435-.11-1.987.332-.552.441-.883 1.103-.883 1.766v4.89L2.87.11C2.208-.11 1.435 0 .883.442.331.883 0 1.545 0 2.208v47.467c0 1.214.994 2.208 2.208 2.208h47.467c1.214 0 2.208-.994 2.098-2.098ZM4.305 5.188l19.429 6.403v35.987h-7.507V35.435a2.214 2.214 0 0 0-2.208-2.208 2.214 2.214 0 0 0-2.207 2.208v12.143H4.305V5.188Zm43.273 42.39H40.07V35.435a2.214 2.214 0 0 0-2.208-2.208 2.214 2.214 0 0 0-2.207 2.208v12.143h-7.507V5.188l19.429 6.403v35.987Z"
                                      }
                                      else if (name == "Rowhouse") {
                                        isNotsingleFamily = true;
                                        svgPath = "M16.385 14.653h-.47V1.777a.672.672 0 0 0-.326-.543.621.621 0 0 0-.614 0L11.9 3.051v-1.31a.672.672 0 0 0-.325-.543.621.621 0 0 0-.615 0L7.704 3.146V1.74a.597.597 0 0 0-.325-.543c-.217-.108-.47-.108-.651.036l-5.354 3.87a.69.69 0 0 0-.253.507v9.042H.615a.634.634 0 0 0-.615.615c0 .326.29.615.615.615H16.385c.326 0 .615-.29.615-.615a.634.634 0 0 0-.615-.615Zm-5.75-11.827v11.827h-2.93V4.563l2.93-1.737ZM2.35 5.9l4.123-2.966v11.72H5.028v-2.641a.634.634 0 0 0-.615-.615.634.634 0 0 0-.615.615v2.64H2.35V5.9Zm9.549 8.753V4.463l2.749-1.637v11.827H11.9Z"
                                      }
                                      else if (name == "Cottage") {
                                        isNotsingleFamily = true;
                                        svgPath = "M8.879.126c-.253-.144-.541-.144-.758 0C2.887 3.375 0 7.706 0 12.29v3.97c0 .397.325.722.722.722h15.52a.779.779 0 0 0 .758-.686V12.29C17 7.67 14.113 3.375 8.879.126ZM6.786 15.574v-4.511h3.356v4.511H6.786Zm8.77 0h-3.97v-5.197a.724.724 0 0 0-.722-.722H6.1a.724.724 0 0 0-.722.722v5.197h-3.97V12.29c0-4.007 2.526-7.796 7.074-10.72 4.584 2.96 7.074 6.75 7.074 10.72v3.284Z"
                                      }
                                      else if (name == "Condo") {
                                        viewBox = "0";
                                        svgPath1 = "M32.435 43.024a2.236 2.236 0 0 0 2.23-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.23 2.236 2.236 0 0 0-2.23 2.23v2.787a2.236 2.236 0 0 0 2.23 2.229Z"

                                        svgPath2 = "M19.952 43.024c1.226 0 2.117-1.003 2.229-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.23 2.236 2.236 0 0 0-2.229 2.23v2.787a2.236 2.236 0 0 0 2.23 2.229Z"

                                        svgPath3 = "M32.435 29.537a2.236 2.236 0 0 0 2.23-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.229 2.236 2.236 0 0 0-2.23 2.23v2.786a2.236 2.236 0 0 0 2.23 2.229Z"

                                        svgPath4 = "M19.952 29.537c1.226 0 2.117-1.003 2.229-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.229 2.236 2.236 0 0 0-2.229 2.23v2.786a2.236 2.236 0 0 0 2.23 2.229Z"

                                        svgPath = "M50.269 47.928h-2.787V17.504l1.784.775c.334.112.557.223.891.223.892 0 1.672-.557 2.007-1.337.446-1.115 0-2.452-1.115-2.898L40.683 9.774V2.229A2.236 2.236 0 0 0 38.454 0a2.236 2.236 0 0 0-2.23 2.23V7.84l-14.49-6.28c-.668-.224-1.448-.224-2.117.222L1.003 14.49C0 15.159-.223 16.496.446 17.5c.669 1.002 2.006 1.225 3.01.557l1.56-1.067v30.938H2.229A2.236 2.236 0 0 0 0 50.158a2.236 2.236 0 0 0 2.23 2.229h47.927c1.226 0 2.341-1.004 2.341-2.23a2.236 2.236 0 0 0-2.23-2.229ZM9.215 14.12l11.851-8.101 21.958 9.547v32.362H9.474v-32.77c0-.374-.094-.728-.259-1.038Z"
                                      }
                                      else if (name == "Apartment") {

                                        svgPath1 = "M2.894 12.551a.726.726 0 0 0-.724.723v.217c0 .398.326.724.724.724.361 0 .687-.29.723-.724v-.217a.726.726 0 0 0-.723-.723Z"

                                        svgPath2 = "M2.894 9.006a.726.726 0 0 0-.724.724v.217c0 .398.326.723.724.723.361 0 .687-.325.723-.723V9.73a.726.726 0 0 0-.723-.724Z"

                                        svgPath3 = "M14.106 14.215c.398 0 .724-.29.724-.724v-.217a.726.726 0 0 0-.724-.723.726.726 0 0 0-.723.723v.217c0 .398.326.724.723.724Z"

                                        svgPath4 = "M14.106 10.67a.726.726 0 0 0 .724-.723V9.73a.726.726 0 0 0-.724-.724.726.726 0 0 0-.723.724v.217c0 .398.326.723.723.723Z"

                                        svgPath5 = "M9.549 7.777c.398 0 .723-.29.723-.724v-.108a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v.108c0 .398.325.724.723.724Z"
                                        svgPath6 = "M7.451 7.777c.398 0 .723-.29.723-.724v-.108a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v.108c0 .398.325.724.723.724Z"
                                        svgPath7 = "M9.549 4.521a.726.726 0 0 0 .723-.723v-.109a.726.726 0 0 0-.723-.723.726.726 0 0 0-.723.723v.109c0 .398.325.723.723.723Z"
                                        svgPath8 = "M7.451 4.521a.726.726 0 0 0 .723-.723v-.109a.726.726 0 0 0-.723-.723.726.726 0 0 0-.723.723v.109c0 .398.325.723.723.723Z"

                                        svgPath = "M16.277 5.787h-3.581V.723A.726.726 0 0 0 11.972 0H5.064a.726.726 0 0 0-.724.723v5.064H.723A.726.726 0 0 0 0 6.511v9.766c0 .397.326.723.723.723h15.553a.726.726 0 0 0 .724-.723V6.51a.725.725 0 0 0-.723-.724Zm-5.064-4.376V15.589h-1.99v-4.412a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v4.412h-1.99V6.511a.717.717 0 0 0-.036-.225V1.41h5.462ZM1.41 7.234h2.93v8.355H1.41V7.234Zm14.178 8.355h-2.893V7.234h2.893v8.355Z"
                                      }
                                      if (name === "Single Family") {

                                        return (
                                          <li class="nav-item" role="presentation" onClick={() => handleselect(name)}>
                                            <a class={style} id="pills-home-tab" data-toggle="pill" href="#pills-home"
                                              role="tab" aria-controls="pills-home" aria-selected="true">
                                              <svg xmlns="http://www.w3.org/2000/svg" width="52.338" height="52.498" viewBox={viewBox}>
                                                <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                                  <path d={svgPath1} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                                  <path d={svgPath2} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                                  <path d={svgPath3} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                                  <path d={svgPath4} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />
                                                  <path d={svgPath5} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                                  <path d={svgPath6} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                                  <path d={svgPath7} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                                  <path d={svgPath8} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />

                                                  <path d={svgPath} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 548" />
                                                </g></svg>
                                            </a>
                                          </li>

                                        );

                                      }
                                      if (name !== "Single Family") {

                                        return (
                                          <li class="nav-item" role="presentation" onClick={() => handleselect(name)}>
                                            <a class={style} id="pills-profile-tab" data-toggle="pill" href="#pills-profile"
                                              role="tab" aria-controls="pills-profile" aria-selected="false">
                                              <svg xmlns="http://www.w3.org/2000/svg" width="52.427" height="52.53" viewBox={viewBox}>

                                                <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                                  <path d={svgPath1} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                                  <path d={svgPath2} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                                  <path d={svgPath3} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                                  <path d={svgPath4} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />
                                                  <path d={svgPath5} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                                  <path d={svgPath6} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                                  <path d={svgPath7} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                                  <path d={svgPath8} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />

                                                  <path d={svgPath} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 548" />
                                                </g>
                                              </svg>
                                            </a>
                                          </li>
                                        );

                                      }
                                      if ((name !== "Single Family" && name !== "Cottage")) {

                                        return (
                                          <li class="nav-item" role="presentation" onClick={() => handleselect(name)}>
                                            <a class={style} id="pills-contact-tab" data-toggle="pill" href="#pills-contact"
                                              role="tab" aria-controls="pills-contact" aria-selected="false">
                                              <svg xmlns="http://www.w3.org/2000/svg" width="52.498" height="52.387" viewBox={viewBox}>
                                                <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                                  <path d={svgPath1} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                                  <path d={svgPath2} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                                  <path d={svgPath3} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                                  <path d={svgPath4} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />
                                                  <path d={svgPath5} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                                  <path d={svgPath6} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                                  <path d={svgPath7} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                                  <path d={svgPath8} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />

                                                  <path d={svgPath} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 548" />
                                                </g></svg>
                                            </a>
                                          </li>

                                        );

                                      }
                                      if ((name === "Apartment" || name === "Condo")) {

                                        return (
                                          <li class="nav-item" role="presentation" onClick={() => handleselect(name)}>
                                            <a class={style} id="pills-contact-tab" data-toggle="pill" href="#pills-contact"
                                              role="tab" aria-controls="pills-contact" aria-selected="false">

                                              <svg xmlns="http://www.w3.org/2000/svg" width="52.498" height="52.387" viewBox={viewBox}>
                                                <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                                  <path d={svgPath1} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                                  <path d={svgPath2} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                                  <path d={svgPath3} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                                  <path d={svgPath4} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />
                                                  <path d={svgPath5} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                                  <path d={svgPath6} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                                  <path d={svgPath7} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                                  <path d={svgPath8} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />

                                                  <path d={svgPath} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 548" />
                                                </g>
                                              </svg>
                                            </a>
                                          </li>
                                        );

                                      }
                                      else {

                                        return (
                                          <button
                                            type="button"
                                            class={style}

                                            onClick={() => handleselect(name)}
                                          >
                                            {name}
                                          </button>
                                        );
                                      }


                                    }


                                    )}
                                  </ul>

                                  <div class={classnametab}>

                                    {customSortFunction(Object.keys(tabs[active])).map(

                                      (item, index) => {

                                        let svgPath = ""; let svgPath1 = ""; let svgPath2 = ""; let svgPath3 = ""; let svgPath4 = "";
                                        let svgPath5 = ""; let svgPath6 = ""; let svgPath7 = ""; let svgPath8 = "";
                                        let viewBox = "0 1.117 17 14.767";

                                        let style = "toptop  mt-2 text-center display";
                                        if (item == "Site Potential") { style = "toptop  mt-2 text-center"; }
                                        if (active == "Single Family") {

                                          svgPath = "/assets/img/home.png"
                                        }
                                        else if (active == "Townhome") {
                                          svgPath = "M43.329,41.65V8.5a1.806,1.806,0,0,0-1.2-1.755L22.273.092a1.791,1.791,0,0,0-1.662.277,1.928,1.928,0,0,0-.739,1.478v4.09L2.418.092A1.791,1.791,0,0,0,.756.369,1.928,1.928,0,0,0,.017,1.847V41.558A1.852,1.852,0,0,0,1.864,43.4H41.574A1.7,1.7,0,0,0,43.329,41.65ZM3.618,4.34,19.872,9.7V39.8h-6.28V29.644a1.847,1.847,0,0,0-3.694,0V39.8H3.618ZM39.82,39.8H33.54V29.644a1.847,1.847,0,1,0-3.694,0V39.8h-6.28V4.34L39.82,9.7Z"
                                        }
                                        else if (active == "Rowhouse") {
                                          svgPath = "/assets/img/row.png"
                                        }
                                        else if (active == "Cottage") {
                                          svgPath = "/assets/img/cot.png"
                                        }
                                        else if (active == "Condo") {
                                          svgPath = "/assets/img/con.png"
                                        }
                                        else if (active == "Apartment") {
                                          svgPath = "/assets/img/Apt.png"
                                        }
                                        if (active == "Single Family") {

                                          svgPath = "m16.667 7.379-4.16-3.096V.723A.725.725 0 0 0 11.784 0a.726.726 0 0 0-.724.723v2.484L8.89 1.59a.706.706 0 0 0-.832 0L.281 7.38c-.325.217-.361.65-.144.976.217.326.65.362.976.145l.724-.535v8.312c0 .397.325.723.723.723h11.864c.398 0 .723-.326.76-.723V8.016l.65.484c.145.109.29.145.435.145.217 0 .434-.073.542-.29.217-.289.181-.76-.144-.976Zm-9.115 8.21v-3.617h1.88v3.617h-1.88Zm6.185 0h-2.858v-4.34a.726.726 0 0 0-.723-.723H6.864a.726.726 0 0 0-.723.723v4.34H3.247V8.174h10.49v7.415ZM3.507 6.728l4.985-3.69 2.79 2.076c.045.043.095.08.15.11l2.02 1.504H3.508Z"
                                        }
                                        else if (active == "Townhome") {
                                          viewBox = "";
                                          svgPath1 = "M13.357 26.493h1.435c1.104 0 2.208-.993 2.208-2.207a2.214 2.214 0 0 0-2.208-2.208h-1.435a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                                          svgPath2 = "M13.357 17.441h1.435c1.104 0 2.208-.993 2.208-2.207a2.214 2.214 0 0 0-2.208-2.208h-1.435a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                                          svgPath3 = "M37.09 26.493h1.436a2.214 2.214 0 0 0 2.208-2.207 2.214 2.214 0 0 0-2.208-2.208H37.09a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                                          svgPath4 = "M37.09 17.441h1.436a2.214 2.214 0 0 0 2.208-2.207 2.214 2.214 0 0 0-2.208-2.208H37.09a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                                          svgPath = "M51.773 49.785v-39.63c0-.993-.552-1.765-1.436-2.097L26.604.11c-.663-.22-1.435-.11-1.987.332-.552.441-.883 1.103-.883 1.766v4.89L2.87.11C2.208-.11 1.435 0 .883.442.331.883 0 1.545 0 2.208v47.467c0 1.214.994 2.208 2.208 2.208h47.467c1.214 0 2.208-.994 2.098-2.098ZM4.305 5.188l19.429 6.403v35.987h-7.507V35.435a2.214 2.214 0 0 0-2.208-2.208 2.214 2.214 0 0 0-2.207 2.208v12.143H4.305V5.188Zm43.273 42.39H40.07V35.435a2.214 2.214 0 0 0-2.208-2.208 2.214 2.214 0 0 0-2.207 2.208v12.143h-7.507V5.188l19.429 6.403v35.987Z"
                                        }
                                        else if (active == "Rowhouse") {
                                          svgPath = "M16.385 14.653h-.47V1.777a.672.672 0 0 0-.326-.543.621.621 0 0 0-.614 0L11.9 3.051v-1.31a.672.672 0 0 0-.325-.543.621.621 0 0 0-.615 0L7.704 3.146V1.74a.597.597 0 0 0-.325-.543c-.217-.108-.47-.108-.651.036l-5.354 3.87a.69.69 0 0 0-.253.507v9.042H.615a.634.634 0 0 0-.615.615c0 .326.29.615.615.615H16.385c.326 0 .615-.29.615-.615a.634.634 0 0 0-.615-.615Zm-5.75-11.827v11.827h-2.93V4.563l2.93-1.737ZM2.35 5.9l4.123-2.966v11.72H5.028v-2.641a.634.634 0 0 0-.615-.615.634.634 0 0 0-.615.615v2.64H2.35V5.9Zm9.549 8.753V4.463l2.749-1.637v11.827H11.9Z"
                                        }
                                        else if (active == "Cottage") {
                                          svgPath = "M8.879.126c-.253-.144-.541-.144-.758 0C2.887 3.375 0 7.706 0 12.29v3.97c0 .397.325.722.722.722h15.52a.779.779 0 0 0 .758-.686V12.29C17 7.67 14.113 3.375 8.879.126ZM6.786 15.574v-4.511h3.356v4.511H6.786Zm8.77 0h-3.97v-5.197a.724.724 0 0 0-.722-.722H6.1a.724.724 0 0 0-.722.722v5.197h-3.97V12.29c0-4.007 2.526-7.796 7.074-10.72 4.584 2.96 7.074 6.75 7.074 10.72v3.284Z"
                                        }
                                        else if (active == "Condo") {
                                          viewBox = "";
                                          svgPath1 = "M32.435 43.024a2.236 2.236 0 0 0 2.23-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.23 2.236 2.236 0 0 0-2.23 2.23v2.787a2.236 2.236 0 0 0 2.23 2.229Z"

                                          svgPath2 = "M19.952 43.024c1.226 0 2.117-1.003 2.229-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.23 2.236 2.236 0 0 0-2.229 2.23v2.787a2.236 2.236 0 0 0 2.23 2.229Z"

                                          svgPath3 = "M32.435 29.537a2.236 2.236 0 0 0 2.23-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.229 2.236 2.236 0 0 0-2.23 2.23v2.786a2.236 2.236 0 0 0 2.23 2.229Z"

                                          svgPath4 = "M19.952 29.537c1.226 0 2.117-1.003 2.229-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.229 2.236 2.236 0 0 0-2.229 2.23v2.786a2.236 2.236 0 0 0 2.23 2.229Z"

                                          svgPath = "M50.269 47.928h-2.787V17.504l1.784.775c.334.112.557.223.891.223.892 0 1.672-.557 2.007-1.337.446-1.115 0-2.452-1.115-2.898L40.683 9.774V2.229A2.236 2.236 0 0 0 38.454 0a2.236 2.236 0 0 0-2.23 2.23V7.84l-14.49-6.28c-.668-.224-1.448-.224-2.117.222L1.003 14.49C0 15.159-.223 16.496.446 17.5c.669 1.002 2.006 1.225 3.01.557l1.56-1.067v30.938H2.229A2.236 2.236 0 0 0 0 50.158a2.236 2.236 0 0 0 2.23 2.229h47.927c1.226 0 2.341-1.004 2.341-2.23a2.236 2.236 0 0 0-2.23-2.229ZM9.215 14.12l11.851-8.101 21.958 9.547v32.362H9.474v-32.77c0-.374-.094-.728-.259-1.038Z"
                                        }
                                        else if (active == "Apartment") {

                                          svgPath1 = "M2.894 12.551a.726.726 0 0 0-.724.723v.217c0 .398.326.724.724.724.361 0 .687-.29.723-.724v-.217a.726.726 0 0 0-.723-.723Z"

                                          svgPath2 = "M2.894 9.006a.726.726 0 0 0-.724.724v.217c0 .398.326.723.724.723.361 0 .687-.325.723-.723V9.73a.726.726 0 0 0-.723-.724Z"

                                          svgPath3 = "M14.106 14.215c.398 0 .724-.29.724-.724v-.217a.726.726 0 0 0-.724-.723.726.726 0 0 0-.723.723v.217c0 .398.326.724.723.724Z"

                                          svgPath4 = "M14.106 10.67a.726.726 0 0 0 .724-.723V9.73a.726.726 0 0 0-.724-.724.726.726 0 0 0-.723.724v.217c0 .398.326.723.723.723Z"

                                          svgPath5 = "M9.549 7.777c.398 0 .723-.29.723-.724v-.108a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v.108c0 .398.325.724.723.724Z"
                                          svgPath6 = "M7.451 7.777c.398 0 .723-.29.723-.724v-.108a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v.108c0 .398.325.724.723.724Z"
                                          svgPath7 = "M9.549 4.521a.726.726 0 0 0 .723-.723v-.109a.726.726 0 0 0-.723-.723.726.726 0 0 0-.723.723v.109c0 .398.325.723.723.723Z"
                                          svgPath8 = "M7.451 4.521a.726.726 0 0 0 .723-.723v-.109a.726.726 0 0 0-.723-.723.726.726 0 0 0-.723.723v.109c0 .398.325.723.723.723Z"

                                          svgPath = "M16.277 5.787h-3.581V.723A.726.726 0 0 0 11.972 0H5.064a.726.726 0 0 0-.724.723v5.064H.723A.726.726 0 0 0 0 6.511v9.766c0 .397.326.723.723.723h15.553a.726.726 0 0 0 .724-.723V6.51a.725.725 0 0 0-.723-.724Zm-5.064-4.376V15.589h-1.99v-4.412a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v4.412h-1.99V6.511a.717.717 0 0 0-.036-.225V1.41h5.462ZM1.41 7.234h2.93v8.355H1.41V7.234Zm14.178 8.355h-2.893V7.234h2.893v8.355Z"
                                        }

                                        return (
                                          <>

                                            <div class={style}>

                                              <h2 class="d-flex align-items-center justify-content-center" style={{ color: "#a0b3c6" }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="52.338" height="52.498" viewBox={viewBox} style={{ marginRight: "3%" }}>
                                                  <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                                    <path d={svgPath1} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                                    <path d={svgPath2} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                                    <path d={svgPath3} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                                    <path d={svgPath4} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />
                                                    <path d={svgPath5} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                                    <path d={svgPath6} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                                    <path d={svgPath7} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                                    <path d={svgPath8} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />

                                                    <path d={svgPath} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 548" />
                                                  </g></svg>
                                                {active} Defaults
                                              </h2>

                                            </div>

                                            <div class="UserDefault card custom-accordian mt-2" style={{ border: "0px !important" }}>

                                              <TabComponent
                                                key={index.toString()}
                                                name={item}
                                                object={tabs[active]}
                                                index={index}
                                                useVals={true}
                                                setTabsImage={setTabsImage}

                                                active={active}
                                                setObject2={(data) => {
                                                  // console.log(data);
                                                  let t = tabs;
                                                  tabs[data.structureType][data.Phase] = tabs[
                                                    data.structureType
                                                  ][data.Phase].map((item) =>
                                                    item.ParameterId === data.ParameterId
                                                      ? data
                                                      : item
                                                  );
                                                  setTabs(t);
                                                }}
                                              />


                                            </div>

                                            <div class="adminDefault card custom-accordian mt-2 " style={{ border: "0px !important" }}>

                                              <TabComponent
                                                key={index.toString()}
                                                name={item}
                                                object={tabs2[active]}
                                                index={index}
                                                useVals={true}
                                                setTabsImage={setTabsImage}

                                                active={active}
                                                setObject2={(data) => {
                                                  // console.log(data);
                                                  let t = tabs2;
                                                  tabs2[data.structureType][data.Phase] = tabs2[
                                                    data.structureType
                                                  ][data.Phase].map((item) =>
                                                    item.ParameterId === data.ParameterId
                                                      ? data
                                                      : item
                                                  );
                                                  setTabs2(t);
                                                }}
                                              />


                                            </div>

                                          </>
                                        );
                                      }
                                    )}

                                    <div class=" mt-2" >
                                      <div class="row " >

                                        <div class="col-md-12 ">
                                          <button
                                            class={"save " + active.replace(/\s/g, "") + "-btn"}
                                            // onClick={(e) => {
                                            //   e.preventDefault();
                                            //   setSubmit(false);
                                            //   document
                                            //     .getElementById("collapseADD")
                                            //     .classList.toggle("collapse");
                                            // }}
                                            style={{ float: "right", minWidth: "23.5%", marginRight: "-1.5%" }}
                                            onClick={onSubmit3}
                                            disabled={loading}
                                            id={active + "-All-Def"}
                                            name={active.replace(/\s/g, "") + "-btn"}
                                          >
                                            {(
                                              <span
                                                name="loader123"
                                                style={{ display: "none" }}
                                                class="loader123 spinner-border spinner-border-sm mr-2"
                                                role="status"
                                                aria-hidden="true"
                                              ></span>
                                            )}
                                            Save changes
                                          </button>
                                        </div>
                                      </div>
                                    </div>


                                  </div>
                                </form>
                              )}
                            </>}
                        </div>
                        {(Cookies.get("username").toLowerCase() === "ryan" || Cookies.get("username").toLowerCase() === "abdul") ?
                          (
                            <div id="menu2" class=" tab-pane fade m">

                              {!(response1) ? <Loader /> :
                                <>
                                  {submit1 && (
                                    <form class="">
                                      <ul class="nav mytab nav-pills justify-content-center mt-2" id="pills-tab" role="tablist">

                                        {Object.keys(tabs1).map((name, item) => {
                                          let style = "nav-link ";
                                          let issingleFamily = false;
                                          let isNotsingleFamily = false;
                                          let isNotsingleFamilyCond = false;
                                          let isAptCond = false;
                                          let svgPath = ""; let svgPath1 = ""; let svgPath2 = ""; let svgPath3 = ""; let svgPath4 = "";
                                          let svgPath5 = ""; let svgPath6 = ""; let svgPath7 = ""; let svgPath8 = "";
                                          let viewBox = "0 1.117 17 14.767";

                                          if (active1 === name) style += "active";

                                          if (name == "Single Family") {
                                            issingleFamily = true;
                                            svgPath = "m16.667 7.379-4.16-3.096V.723A.725.725 0 0 0 11.784 0a.726.726 0 0 0-.724.723v2.484L8.89 1.59a.706.706 0 0 0-.832 0L.281 7.38c-.325.217-.361.65-.144.976.217.326.65.362.976.145l.724-.535v8.312c0 .397.325.723.723.723h11.864c.398 0 .723-.326.76-.723V8.016l.65.484c.145.109.29.145.435.145.217 0 .434-.073.542-.29.217-.289.181-.76-.144-.976Zm-9.115 8.21v-3.617h1.88v3.617h-1.88Zm6.185 0h-2.858v-4.34a.726.726 0 0 0-.723-.723H6.864a.726.726 0 0 0-.723.723v4.34H3.247V8.174h10.49v7.415ZM3.507 6.728l4.985-3.69 2.79 2.076c.045.043.095.08.15.11l2.02 1.504H3.508Z"
                                          }
                                          else if (name == "Townhome") {
                                            isNotsingleFamily = true;
                                            viewBox = "0";
                                            svgPath1 = "M13.357 26.493h1.435c1.104 0 2.208-.993 2.208-2.207a2.214 2.214 0 0 0-2.208-2.208h-1.435a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                                            svgPath2 = "M13.357 17.441h1.435c1.104 0 2.208-.993 2.208-2.207a2.214 2.214 0 0 0-2.208-2.208h-1.435a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                                            svgPath3 = "M37.09 26.493h1.436a2.214 2.214 0 0 0 2.208-2.207 2.214 2.214 0 0 0-2.208-2.208H37.09a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                                            svgPath4 = "M37.09 17.441h1.436a2.214 2.214 0 0 0 2.208-2.207 2.214 2.214 0 0 0-2.208-2.208H37.09a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                                            svgPath = "M51.773 49.785v-39.63c0-.993-.552-1.765-1.436-2.097L26.604.11c-.663-.22-1.435-.11-1.987.332-.552.441-.883 1.103-.883 1.766v4.89L2.87.11C2.208-.11 1.435 0 .883.442.331.883 0 1.545 0 2.208v47.467c0 1.214.994 2.208 2.208 2.208h47.467c1.214 0 2.208-.994 2.098-2.098ZM4.305 5.188l19.429 6.403v35.987h-7.507V35.435a2.214 2.214 0 0 0-2.208-2.208 2.214 2.214 0 0 0-2.207 2.208v12.143H4.305V5.188Zm43.273 42.39H40.07V35.435a2.214 2.214 0 0 0-2.208-2.208 2.214 2.214 0 0 0-2.207 2.208v12.143h-7.507V5.188l19.429 6.403v35.987Z"
                                          }
                                          else if (name == "Rowhouse") {
                                            isNotsingleFamily = true;
                                            svgPath = "M16.385 14.653h-.47V1.777a.672.672 0 0 0-.326-.543.621.621 0 0 0-.614 0L11.9 3.051v-1.31a.672.672 0 0 0-.325-.543.621.621 0 0 0-.615 0L7.704 3.146V1.74a.597.597 0 0 0-.325-.543c-.217-.108-.47-.108-.651.036l-5.354 3.87a.69.69 0 0 0-.253.507v9.042H.615a.634.634 0 0 0-.615.615c0 .326.29.615.615.615H16.385c.326 0 .615-.29.615-.615a.634.634 0 0 0-.615-.615Zm-5.75-11.827v11.827h-2.93V4.563l2.93-1.737ZM2.35 5.9l4.123-2.966v11.72H5.028v-2.641a.634.634 0 0 0-.615-.615.634.634 0 0 0-.615.615v2.64H2.35V5.9Zm9.549 8.753V4.463l2.749-1.637v11.827H11.9Z"
                                          }
                                          else if (name == "Cottage") {
                                            isNotsingleFamily = true;
                                            svgPath = "M8.879.126c-.253-.144-.541-.144-.758 0C2.887 3.375 0 7.706 0 12.29v3.97c0 .397.325.722.722.722h15.52a.779.779 0 0 0 .758-.686V12.29C17 7.67 14.113 3.375 8.879.126ZM6.786 15.574v-4.511h3.356v4.511H6.786Zm8.77 0h-3.97v-5.197a.724.724 0 0 0-.722-.722H6.1a.724.724 0 0 0-.722.722v5.197h-3.97V12.29c0-4.007 2.526-7.796 7.074-10.72 4.584 2.96 7.074 6.75 7.074 10.72v3.284Z"
                                          }
                                          else if (name == "Condo") {
                                            viewBox = "0";
                                            svgPath1 = "M32.435 43.024a2.236 2.236 0 0 0 2.23-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.23 2.236 2.236 0 0 0-2.23 2.23v2.787a2.236 2.236 0 0 0 2.23 2.229Z"

                                            svgPath2 = "M19.952 43.024c1.226 0 2.117-1.003 2.229-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.23 2.236 2.236 0 0 0-2.229 2.23v2.787a2.236 2.236 0 0 0 2.23 2.229Z"

                                            svgPath3 = "M32.435 29.537a2.236 2.236 0 0 0 2.23-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.229 2.236 2.236 0 0 0-2.23 2.23v2.786a2.236 2.236 0 0 0 2.23 2.229Z"

                                            svgPath4 = "M19.952 29.537c1.226 0 2.117-1.003 2.229-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.229 2.236 2.236 0 0 0-2.229 2.23v2.786a2.236 2.236 0 0 0 2.23 2.229Z"

                                            svgPath = "M50.269 47.928h-2.787V17.504l1.784.775c.334.112.557.223.891.223.892 0 1.672-.557 2.007-1.337.446-1.115 0-2.452-1.115-2.898L40.683 9.774V2.229A2.236 2.236 0 0 0 38.454 0a2.236 2.236 0 0 0-2.23 2.23V7.84l-14.49-6.28c-.668-.224-1.448-.224-2.117.222L1.003 14.49C0 15.159-.223 16.496.446 17.5c.669 1.002 2.006 1.225 3.01.557l1.56-1.067v30.938H2.229A2.236 2.236 0 0 0 0 50.158a2.236 2.236 0 0 0 2.23 2.229h47.927c1.226 0 2.341-1.004 2.341-2.23a2.236 2.236 0 0 0-2.23-2.229ZM9.215 14.12l11.851-8.101 21.958 9.547v32.362H9.474v-32.77c0-.374-.094-.728-.259-1.038Z"
                                          }
                                          else if (name == "Apartment") {

                                            svgPath1 = "M2.894 12.551a.726.726 0 0 0-.724.723v.217c0 .398.326.724.724.724.361 0 .687-.29.723-.724v-.217a.726.726 0 0 0-.723-.723Z"

                                            svgPath2 = "M2.894 9.006a.726.726 0 0 0-.724.724v.217c0 .398.326.723.724.723.361 0 .687-.325.723-.723V9.73a.726.726 0 0 0-.723-.724Z"

                                            svgPath3 = "M14.106 14.215c.398 0 .724-.29.724-.724v-.217a.726.726 0 0 0-.724-.723.726.726 0 0 0-.723.723v.217c0 .398.326.724.723.724Z"

                                            svgPath4 = "M14.106 10.67a.726.726 0 0 0 .724-.723V9.73a.726.726 0 0 0-.724-.724.726.726 0 0 0-.723.724v.217c0 .398.326.723.723.723Z"

                                            svgPath5 = "M9.549 7.777c.398 0 .723-.29.723-.724v-.108a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v.108c0 .398.325.724.723.724Z"
                                            svgPath6 = "M7.451 7.777c.398 0 .723-.29.723-.724v-.108a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v.108c0 .398.325.724.723.724Z"
                                            svgPath7 = "M9.549 4.521a.726.726 0 0 0 .723-.723v-.109a.726.726 0 0 0-.723-.723.726.726 0 0 0-.723.723v.109c0 .398.325.723.723.723Z"
                                            svgPath8 = "M7.451 4.521a.726.726 0 0 0 .723-.723v-.109a.726.726 0 0 0-.723-.723.726.726 0 0 0-.723.723v.109c0 .398.325.723.723.723Z"

                                            svgPath = "M16.277 5.787h-3.581V.723A.726.726 0 0 0 11.972 0H5.064a.726.726 0 0 0-.724.723v5.064H.723A.726.726 0 0 0 0 6.511v9.766c0 .397.326.723.723.723h15.553a.726.726 0 0 0 .724-.723V6.51a.725.725 0 0 0-.723-.724Zm-5.064-4.376V15.589h-1.99v-4.412a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v4.412h-1.99V6.511a.717.717 0 0 0-.036-.225V1.41h5.462ZM1.41 7.234h2.93v8.355H1.41V7.234Zm14.178 8.355h-2.893V7.234h2.893v8.355Z"
                                          }
                                          if (name === "Single Family") {

                                            return (
                                              <li class="nav-item" role="presentation" onClick={() => setActive1(name)}>
                                                <a class={style} id="pills-home-tab" data-toggle="pill" href="#pills-home"
                                                  role="tab" aria-controls="pills-home" aria-selected="true">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="52.338" height="52.498" viewBox={viewBox}>
                                                    <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                                      <path d={svgPath1} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                                      <path d={svgPath2} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                                      <path d={svgPath3} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                                      <path d={svgPath4} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />
                                                      <path d={svgPath5} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                                      <path d={svgPath6} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                                      <path d={svgPath7} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                                      <path d={svgPath8} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />

                                                      <path d={svgPath} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 548" />
                                                    </g></svg>
                                                </a>
                                              </li>

                                            );

                                          }
                                          if (name !== "Single Family") {

                                            return (
                                              <li class="nav-item" role="presentation" onClick={() => setActive1(name)}>
                                                <a class={style} id="pills-profile-tab" data-toggle="pill" href="#pills-profile"
                                                  role="tab" aria-controls="pills-profile" aria-selected="false">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="52.427" height="52.53" viewBox={viewBox}>

                                                    <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                                      <path d={svgPath1} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                                      <path d={svgPath2} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                                      <path d={svgPath3} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                                      <path d={svgPath4} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />
                                                      <path d={svgPath5} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                                      <path d={svgPath6} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                                      <path d={svgPath7} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                                      <path d={svgPath8} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />

                                                      <path d={svgPath} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 548" />
                                                    </g>
                                                  </svg>
                                                </a>
                                              </li>
                                            );

                                          }
                                          if ((name !== "Single Family" && name !== "Cottage")) {

                                            return (
                                              <li class="nav-item" role="presentation" onClick={() => setActive1(name)}>
                                                <a class={style} id="pills-contact-tab" data-toggle="pill" href="#pills-contact"
                                                  role="tab" aria-controls="pills-contact" aria-selected="false">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="52.498" height="52.387" viewBox={viewBox}>
                                                    <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                                      <path d={svgPath1} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                                      <path d={svgPath2} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                                      <path d={svgPath3} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                                      <path d={svgPath4} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />
                                                      <path d={svgPath5} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                                      <path d={svgPath6} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                                      <path d={svgPath7} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                                      <path d={svgPath8} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />

                                                      <path d={svgPath} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 548" />
                                                    </g></svg>
                                                </a>
                                              </li>

                                            );

                                          }
                                          if ((name === "Apartment" || name === "Condo")) {

                                            return (
                                              <li class="nav-item" role="presentation" onClick={() => setActive1(name)}>
                                                <a class={style} id="pills-contact-tab" data-toggle="pill" href="#pills-contact"
                                                  role="tab" aria-controls="pills-contact" aria-selected="false">

                                                  <svg xmlns="http://www.w3.org/2000/svg" width="52.498" height="52.387" viewBox={viewBox}>
                                                    <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                                      <path d={svgPath1} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                                      <path d={svgPath2} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                                      <path d={svgPath3} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                                      <path d={svgPath4} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />
                                                      <path d={svgPath5} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                                      <path d={svgPath6} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                                      <path d={svgPath7} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                                      <path d={svgPath8} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />

                                                      <path d={svgPath} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 548" />
                                                    </g>
                                                  </svg>
                                                </a>
                                              </li>
                                            );

                                          }
                                          else {

                                            return (
                                              <button
                                                type="button"
                                                class={style}

                                                onClick={() => setActive1(name)}
                                              >
                                                {name}
                                              </button>
                                            );
                                          }


                                        }


                                        )}
                                      </ul>
                                      <div class={classnametab}>
                                        {customSortFunction(Object.keys(tabs1[active1])).map(

                                          (item, index) => {
                                            let svgPath = ""; let svgPath1 = ""; let svgPath2 = ""; let svgPath3 = ""; let svgPath4 = "";
                                            let svgPath5 = ""; let svgPath6 = ""; let svgPath7 = ""; let svgPath8 = "";
                                            let viewBox = "0 1.117 17 14.767";

                                            let style = "toptop  mt-2 text-center display";
                                            if (item == "Site Potential") { style = "toptop  mt-2 text-center"; }
                                            if (active1 == "Single Family") {

                                              svgPath = "/assets/img/home.png"
                                            }
                                            else if (active1 == "Townhome") {
                                              svgPath = "M43.329,41.65V8.5a1.806,1.806,0,0,0-1.2-1.755L22.273.092a1.791,1.791,0,0,0-1.662.277,1.928,1.928,0,0,0-.739,1.478v4.09L2.418.092A1.791,1.791,0,0,0,.756.369,1.928,1.928,0,0,0,.017,1.847V41.558A1.852,1.852,0,0,0,1.864,43.4H41.574A1.7,1.7,0,0,0,43.329,41.65ZM3.618,4.34,19.872,9.7V39.8h-6.28V29.644a1.847,1.847,0,0,0-3.694,0V39.8H3.618ZM39.82,39.8H33.54V29.644a1.847,1.847,0,1,0-3.694,0V39.8h-6.28V4.34L39.82,9.7Z"
                                            }
                                            else if (active1 == "Rowhouse") {
                                              svgPath = "/assets/img/row.png"
                                            }
                                            else if (active1 == "Cottage") {
                                              svgPath = "/assets/img/cot.png"
                                            }
                                            else if (active1 == "Condo") {
                                              svgPath = "/assets/img/con.png"
                                            }
                                            else if (active1 == "Apartment") {
                                              svgPath = "/assets/img/Apt.png"
                                            }
                                            if (active1 == "Single Family") {

                                              svgPath = "m16.667 7.379-4.16-3.096V.723A.725.725 0 0 0 11.784 0a.726.726 0 0 0-.724.723v2.484L8.89 1.59a.706.706 0 0 0-.832 0L.281 7.38c-.325.217-.361.65-.144.976.217.326.65.362.976.145l.724-.535v8.312c0 .397.325.723.723.723h11.864c.398 0 .723-.326.76-.723V8.016l.65.484c.145.109.29.145.435.145.217 0 .434-.073.542-.29.217-.289.181-.76-.144-.976Zm-9.115 8.21v-3.617h1.88v3.617h-1.88Zm6.185 0h-2.858v-4.34a.726.726 0 0 0-.723-.723H6.864a.726.726 0 0 0-.723.723v4.34H3.247V8.174h10.49v7.415ZM3.507 6.728l4.985-3.69 2.79 2.076c.045.043.095.08.15.11l2.02 1.504H3.508Z"
                                            }
                                            else if (active1 == "Townhome") {
                                              viewBox = "";
                                              svgPath1 = "M13.357 26.493h1.435c1.104 0 2.208-.993 2.208-2.207a2.214 2.214 0 0 0-2.208-2.208h-1.435a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                                              svgPath2 = "M13.357 17.441h1.435c1.104 0 2.208-.993 2.208-2.207a2.214 2.214 0 0 0-2.208-2.208h-1.435a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                                              svgPath3 = "M37.09 26.493h1.436a2.214 2.214 0 0 0 2.208-2.207 2.214 2.214 0 0 0-2.208-2.208H37.09a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                                              svgPath4 = "M37.09 17.441h1.436a2.214 2.214 0 0 0 2.208-2.207 2.214 2.214 0 0 0-2.208-2.208H37.09a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                                              svgPath = "M51.773 49.785v-39.63c0-.993-.552-1.765-1.436-2.097L26.604.11c-.663-.22-1.435-.11-1.987.332-.552.441-.883 1.103-.883 1.766v4.89L2.87.11C2.208-.11 1.435 0 .883.442.331.883 0 1.545 0 2.208v47.467c0 1.214.994 2.208 2.208 2.208h47.467c1.214 0 2.208-.994 2.098-2.098ZM4.305 5.188l19.429 6.403v35.987h-7.507V35.435a2.214 2.214 0 0 0-2.208-2.208 2.214 2.214 0 0 0-2.207 2.208v12.143H4.305V5.188Zm43.273 42.39H40.07V35.435a2.214 2.214 0 0 0-2.208-2.208 2.214 2.214 0 0 0-2.207 2.208v12.143h-7.507V5.188l19.429 6.403v35.987Z"
                                            }
                                            else if (active1 == "Rowhouse") {
                                              svgPath = "M16.385 14.653h-.47V1.777a.672.672 0 0 0-.326-.543.621.621 0 0 0-.614 0L11.9 3.051v-1.31a.672.672 0 0 0-.325-.543.621.621 0 0 0-.615 0L7.704 3.146V1.74a.597.597 0 0 0-.325-.543c-.217-.108-.47-.108-.651.036l-5.354 3.87a.69.69 0 0 0-.253.507v9.042H.615a.634.634 0 0 0-.615.615c0 .326.29.615.615.615H16.385c.326 0 .615-.29.615-.615a.634.634 0 0 0-.615-.615Zm-5.75-11.827v11.827h-2.93V4.563l2.93-1.737ZM2.35 5.9l4.123-2.966v11.72H5.028v-2.641a.634.634 0 0 0-.615-.615.634.634 0 0 0-.615.615v2.64H2.35V5.9Zm9.549 8.753V4.463l2.749-1.637v11.827H11.9Z"
                                            }
                                            else if (active1 == "Cottage") {
                                              svgPath = "M8.879.126c-.253-.144-.541-.144-.758 0C2.887 3.375 0 7.706 0 12.29v3.97c0 .397.325.722.722.722h15.52a.779.779 0 0 0 .758-.686V12.29C17 7.67 14.113 3.375 8.879.126ZM6.786 15.574v-4.511h3.356v4.511H6.786Zm8.77 0h-3.97v-5.197a.724.724 0 0 0-.722-.722H6.1a.724.724 0 0 0-.722.722v5.197h-3.97V12.29c0-4.007 2.526-7.796 7.074-10.72 4.584 2.96 7.074 6.75 7.074 10.72v3.284Z"
                                            }
                                            else if (active1 == "Condo") {
                                              viewBox = "";
                                              svgPath1 = "M32.435 43.024a2.236 2.236 0 0 0 2.23-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.23 2.236 2.236 0 0 0-2.23 2.23v2.787a2.236 2.236 0 0 0 2.23 2.229Z"

                                              svgPath2 = "M19.952 43.024c1.226 0 2.117-1.003 2.229-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.23 2.236 2.236 0 0 0-2.229 2.23v2.787a2.236 2.236 0 0 0 2.23 2.229Z"

                                              svgPath3 = "M32.435 29.537a2.236 2.236 0 0 0 2.23-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.229 2.236 2.236 0 0 0-2.23 2.23v2.786a2.236 2.236 0 0 0 2.23 2.229Z"

                                              svgPath4 = "M19.952 29.537c1.226 0 2.117-1.003 2.229-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.229 2.236 2.236 0 0 0-2.229 2.23v2.786a2.236 2.236 0 0 0 2.23 2.229Z"

                                              svgPath = "M50.269 47.928h-2.787V17.504l1.784.775c.334.112.557.223.891.223.892 0 1.672-.557 2.007-1.337.446-1.115 0-2.452-1.115-2.898L40.683 9.774V2.229A2.236 2.236 0 0 0 38.454 0a2.236 2.236 0 0 0-2.23 2.23V7.84l-14.49-6.28c-.668-.224-1.448-.224-2.117.222L1.003 14.49C0 15.159-.223 16.496.446 17.5c.669 1.002 2.006 1.225 3.01.557l1.56-1.067v30.938H2.229A2.236 2.236 0 0 0 0 50.158a2.236 2.236 0 0 0 2.23 2.229h47.927c1.226 0 2.341-1.004 2.341-2.23a2.236 2.236 0 0 0-2.23-2.229ZM9.215 14.12l11.851-8.101 21.958 9.547v32.362H9.474v-32.77c0-.374-.094-.728-.259-1.038Z"
                                            }
                                            else if (active1 == "Apartment") {

                                              svgPath1 = "M2.894 12.551a.726.726 0 0 0-.724.723v.217c0 .398.326.724.724.724.361 0 .687-.29.723-.724v-.217a.726.726 0 0 0-.723-.723Z"

                                              svgPath2 = "M2.894 9.006a.726.726 0 0 0-.724.724v.217c0 .398.326.723.724.723.361 0 .687-.325.723-.723V9.73a.726.726 0 0 0-.723-.724Z"

                                              svgPath3 = "M14.106 14.215c.398 0 .724-.29.724-.724v-.217a.726.726 0 0 0-.724-.723.726.726 0 0 0-.723.723v.217c0 .398.326.724.723.724Z"

                                              svgPath4 = "M14.106 10.67a.726.726 0 0 0 .724-.723V9.73a.726.726 0 0 0-.724-.724.726.726 0 0 0-.723.724v.217c0 .398.326.723.723.723Z"

                                              svgPath5 = "M9.549 7.777c.398 0 .723-.29.723-.724v-.108a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v.108c0 .398.325.724.723.724Z"
                                              svgPath6 = "M7.451 7.777c.398 0 .723-.29.723-.724v-.108a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v.108c0 .398.325.724.723.724Z"
                                              svgPath7 = "M9.549 4.521a.726.726 0 0 0 .723-.723v-.109a.726.726 0 0 0-.723-.723.726.726 0 0 0-.723.723v.109c0 .398.325.723.723.723Z"
                                              svgPath8 = "M7.451 4.521a.726.726 0 0 0 .723-.723v-.109a.726.726 0 0 0-.723-.723.726.726 0 0 0-.723.723v.109c0 .398.325.723.723.723Z"

                                              svgPath = "M16.277 5.787h-3.581V.723A.726.726 0 0 0 11.972 0H5.064a.726.726 0 0 0-.724.723v5.064H.723A.726.726 0 0 0 0 6.511v9.766c0 .397.326.723.723.723h15.553a.726.726 0 0 0 .724-.723V6.51a.725.725 0 0 0-.723-.724Zm-5.064-4.376V15.589h-1.99v-4.412a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v4.412h-1.99V6.511a.717.717 0 0 0-.036-.225V1.41h5.462ZM1.41 7.234h2.93v8.355H1.41V7.234Zm14.178 8.355h-2.893V7.234h2.893v8.355Z"
                                            }
                                            return (
                                              <>

                                                <div class={style}>
                                                  <h2 class="d-flex align-items-center justify-content-center" style={{ color: "#a0b3c6" }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="52.338" height="52.498" viewBox={viewBox} style={{ marginRight: "3%" }}>
                                                      <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                                        <path d={svgPath1} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                                        <path d={svgPath2} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                                        <path d={svgPath3} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                                        <path d={svgPath4} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />
                                                        <path d={svgPath5} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                                        <path d={svgPath6} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                                        <path d={svgPath7} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                                        <path d={svgPath8} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />

                                                        <path d={svgPath} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 548" />
                                                      </g></svg>
                                                    {active1} Defaults
                                                  </h2>

                                                </div>
                                                <div class="card custom-accordian mt-2" style={{ border: "0px !important" }}>

                                                  <TabComponent
                                                    key={index.toString()}
                                                    name={item}
                                                    object={tabs1[active1]}
                                                    index={index}
                                                    useVals={true}
                                                    setTabsImage={setTabsImage}
                                                    isadmin="1"
                                                    active={active1}
                                                    setObject2={(data) => {
                                                      // console.log(data);
                                                      let t = tabs1;
                                                      tabs1[data.structureType][data.Phase] = tabs1[
                                                        data.structureType
                                                      ][data.Phase].map((item) =>
                                                        item.ParameterId === data.ParameterId
                                                          ? data
                                                          : item
                                                      );
                                                      setTabs1(t);
                                                    }}
                                                  />


                                                </div>
                                              </>
                                            );
                                          }
                                        )}

                                        <div class=" mt-2" >
                                          <div class="row " >

                                            <div class="col-md-12 ">
                                              <button
                                                class="save"
                                                // onClick={(e) => {
                                                //   e.preventDefault();
                                                //   setSubmit(false);
                                                //   document
                                                //     .getElementById("collapseADD")
                                                //     .classList.toggle("collapse");
                                                // }}
                                                style={{ float: "right", minWidth: "23.5%", marginRight: "-1.5%" }}
                                                onClick={onSubmit1}
                                                disabled={loading}
                                                id={active1 + "-All-Def"}
                                              >
                                                {(
                                                  <span
                                                    name="loader123"
                                                    style={{ display: "none" }}
                                                    class="loader123 spinner-border spinner-border-sm mr-2"
                                                    role="status"
                                                    aria-hidden="true"
                                                  ></span>
                                                )}
                                                {loading && <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>}
                                                Save changes
                                              </button>
                                            </div>
                                          </div>
                                        </div>


                                      </div>
                                    </form>
                                  )}
                                </>}
                            </div>)
                          : ""}
                      </div> </div>
                  </>

                }


              </div>
              <div class="col-md-3 city-dashboard img Landbrige_map" >
                <div class="bg_content">
                  <img src="../assets/img/LB-Icon-White.svg" alt="LB-Icon-White.svg"></img>
                  <h2>land analysis made simple</h2>
                </div>
              </div>
            </div>
          </div>  </div>  </div>  </div>

  )
}